module.exports = __webpack_public_path__ + "img/1_002.3870da1e.jpg";